import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Card, Row, Col, Table, Spinner } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { objectShowNumber } from '@app/utils/define';

import {
  nhiemVuCaNhanDebugCurrentUserAction,
  nhiemVuCaNhanGetProjectTasksAction,
  nhiemVuCaNhanGetOtherTasksAction,
  nhiemVuCaNhanGetYeuCauTasksAction,
  nhiemVuCaNhanGetHoTroTasksAction,
} from '@app/store/reducers/nhiemvucanhan';

import {
  TRANG_THAI_CONG_VIEC_OPTIONS,
  TRANG_THAI_KHAC_OPTIONS,
  TRANG_THAI_YEU_CAU_OPTIONS,
  TRANG_THAI_HO_TRO_OPTIONS,

  MUC_DO_UU_TIEN,
  MUC_DO_PHUC_TAP_OPTIONS,
  LOAI_LOI_OPTIONS,

  mapMucDoUuTienLabel,
  mapTrangThaiCongViecLabel,
  mapTrangThaiKhacLabel,
  mapTrangThaiYeuCauLabel,
  mapTrangThaiHoTroLabel,
  mapMucDoPhucTapLabel,
  mapLoaiLoiLabel,
} from '@app/store/constants';

import { linhVucGetAllAction } from '@store/reducers/linhvuc';
import { khoaGetAllAction } from '@store/reducers/khoa';
import { nguoiPhoiHopGetAllAction } from '@store/reducers/nguoiphoihop';

const COLUMN_STYLE_MAP = {
  canlam: { headerBg: '#e1e5f2', headerText: '#333333', border: '#c4ccdd', bodyBg: '#f7f9fc' },
  danglam: { headerBg: '#d3e5ff', headerText: '#245b8f', border: '#aac6ff', bodyBg: '#f3f7ff' },
  choduyet: { headerBg: '#ffe0b2', headerText: '#8f6a24', border: '#ffc875', bodyBg: '#fff5e0' },
  hoanthanh: { headerBg: '#cef4e4', headerText: '#247a55', border: '#a0e0c6', bodyBg: '#f1fbf6' },
};

const getStatusStyleProject = (status) => {
  const opt = TRANG_THAI_CONG_VIEC_OPTIONS.find((x) => x.value === status || x.key === status);
  const key = opt ? opt.key : null;
  const style = key ? COLUMN_STYLE_MAP[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.headerBg,
    border: `1px solid ${style.border}`,
    color: style.headerText,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

const toCongViecStatusKey = (status) => {
  const opt = TRANG_THAI_CONG_VIEC_OPTIONS.find((x) => x.value === status || x.key === status);
  return opt ? opt.key : null;
};

const getEffectiveTienDoProjectTask = (item) => {
  const key = toCongViecStatusKey(item?.status);
  if (key === 'hoanthanh') return 100;
  return item?.tienDo ?? null;
};

const STATUS_COLOR_MAP_KHAC = {
  chuabatdau: { bg: '#e1e5f2', text: '#333333', border: '#c4ccdd' },
  dangthuchien: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiKhacKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_KHAC_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_KHAC_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleNhiemVuKhac = (status) => {
  const key = toTrangThaiKhacKey(status);
  const style = key ? STATUS_COLOR_MAP_KHAC[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

// Yêu cầu: 0..3
const STATUS_COLOR_MAP_YEUCAU = {
  chophanhoi: { bg: '#e1e5f2', text: '#333333', border: '#c4ccdd' },
  dangtest: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  chonangcap: { bg: '#ffe0b2', text: '#8f6a24', border: '#ffc875' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiYeuCauKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_YEU_CAU_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_YEU_CAU_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleYeuCau = (status) => {
  const key = toTrangThaiYeuCauKey(status);
  const style = key ? STATUS_COLOR_MAP_YEUCAU[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

// HoTro: 0..1
const STATUS_COLOR_MAP_HOTRO = {
  dangthuchien: { bg: '#d3e5ff', text: '#245b8f', border: '#aac6ff' },
  hoanthanh: { bg: '#cef4e4', text: '#247a55', border: '#a0e0c6' },
};

const toTrangThaiHoTroKey = (valueOrKey) => {
  const opt =
    TRANG_THAI_HO_TRO_OPTIONS.find((o) => o.value === valueOrKey || o.key === valueOrKey) ||
    TRANG_THAI_HO_TRO_OPTIONS.find((o) => o.value === Number(valueOrKey));
  return opt ? opt.key : null;
};

const getStatusStyleHoTro = (status) => {
  const key = toTrangThaiHoTroKey(status);
  const style = key ? STATUS_COLOR_MAP_HOTRO[key] : null;

  if (!style) {
    return {
      backgroundColor: '#e9ecef',
      border: '1px solid #ced4da',
      color: '#495057',
      borderRadius: '12px',
      padding: '2px 8px',
      fontSize: '0.85rem',
      display: 'inline-block',
      minWidth: '90px',
      textAlign: 'center',
    };
  }

  return {
    backgroundColor: style.bg,
    border: `1px solid ${style.border}`,
    color: style.text,
    borderRadius: '12px',
    padding: '2px 8px',
    fontSize: '0.85rem',
    display: 'inline-block',
    minWidth: '90px',
    textAlign: 'center',
  };
};

const safeText = (v) => (v == null ? '' : String(v));

const formatDate = (d) => {
  if (!d) return '';
  const dt = new Date(d);
  if (Number.isNaN(dt.getTime())) return '';
  return dt.toLocaleDateString();
};

const getTicketDisplay = (url) => {
  if (!url) return '';
  // Bắt đúng dạng GitHub issue
  const match = url.match(/github\.com\/.+\/issues\/(\d+)/);
  // Nếu đúng → trả về số ticket
  if (match) return match[1];
  // Nếu không đúng → hiển thị full link
    return 'Link';
};

const renderTicketLink = (url) => {
  if (!url) return '';
  return (
    <a href={url} target="_blank" rel="noopener noreferrer" title={url}>
      {getTicketDisplay(url)}
    </a>
  );
};

const pickName = (obj) =>
  obj?.name ||
  obj?.ten ||
  obj?.tenKhoa ||
  obj?.tenLinhVuc ||
  obj?.title ||
  obj?.label ||
  '';

const NhiemVuCaNhan = () => {
  const dispatch = useDispatch();

  const {
    loadingUser,
    loadingProjectTasks,
    loadingOtherTasks,
    loadingYeuCauTasks,
    loadingHoTroTasks,

    errorUser,
    errorProjectTasks,
    errorOtherTasks,
    errorYeuCauTasks,
    errorHoTroTasks,

    currentUser,
    projectTasks,
    otherTasks,
    yeuCauTasks,
    hoTroTasks,
  } = useSelector((state) => state.nhiemVuCaNhan);

  // lấy list khoa/linhvuc để map tên
  const khoaState = useSelector((state) => state.khoa || {});
  const linhVucState = useSelector((state) => state.linhvuc || {});
  const nguoiPhoiHopState = useSelector((state) => state.nguoiPhoiHop || {});

  const khoaList = Array.isArray(khoaState.listKhoa) ? khoaState.listKhoa : [];
  const linhVucList = Array.isArray(linhVucState.listLinhVuc) ? linhVucState.listLinhVuc : [];
  const nguoiPhoiHopList = Array.isArray(nguoiPhoiHopState.listNguoiPhoiHop)
    ? nguoiPhoiHopState.listNguoiPhoiHop
    : [];

  const loading =
    loadingUser || loadingProjectTasks || loadingOtherTasks || loadingYeuCauTasks || loadingHoTroTasks;

  const [filterTab, setFilterTab] = useState('all');

  // filters DEV
  const [projectStatusFilter, setProjectStatusFilter] = useState('');
  const [projectPriorityFilter, setProjectPriorityFilter] = useState('');

  // filters OTHER
  const [otherStatusFilter, setOtherStatusFilter] = useState('');
  const [otherPriorityFilter, setOtherPriorityFilter] = useState('');

  // filters YEUCAU
  const [yeuCauStatusFilter, setYeuCauStatusFilter] = useState('');
  const [yeuCauPriorityFilter, setYeuCauPriorityFilter] = useState('');

  // filters HOTRO
  const [hoTroStatusFilter, setHoTroStatusFilter] = useState('');
  const [hoTroLoaiLoiFilter, setHoTroLoaiLoiFilter] = useState('');
  const [hoTroMucDoFilter, setHoTroMucDoFilter] = useState('');

  // paging
  const [pageProject, setPageProject] = useState(1);
  const [pageSizeProject, setPageSizeProject] = useState(20);

  const [pageOther, setPageOther] = useState(1);
  const [pageSizeOther, setPageSizeOther] = useState(20);

  const [pageYeuCau, setPageYeuCau] = useState(1);
  const [pageSizeYeuCau, setPageSizeYeuCau] = useState(20);

  const [pageHoTro, setPageHoTro] = useState(1);
  const [pageSizeHoTro, setPageSizeHoTro] = useState(20);

  useEffect(() => {
    dispatch(nhiemVuCaNhanDebugCurrentUserAction());
    // load danh mục để map tên
    dispatch(linhVucGetAllAction());
    dispatch(khoaGetAllAction());
    dispatch(nguoiPhoiHopGetAllAction());
  }, [dispatch]);

  // load dev
  useEffect(() => {
    const params = {};
    if (projectStatusFilter !== '') params.status = Number(projectStatusFilter);
    if (projectPriorityFilter !== '') params.priority = Number(projectPriorityFilter);
    dispatch(nhiemVuCaNhanGetProjectTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, projectStatusFilter, projectPriorityFilter]);

  // load other
  useEffect(() => {
    const params = {};
    if (otherStatusFilter !== '') params.status = Number(otherStatusFilter);
    if (otherPriorityFilter !== '') params.priority = Number(otherPriorityFilter);
    dispatch(nhiemVuCaNhanGetOtherTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, otherStatusFilter, otherPriorityFilter]);

  // load yeucau
  useEffect(() => {
    const params = {};
    if (yeuCauStatusFilter !== '') params.status = Number(yeuCauStatusFilter);
    if (yeuCauPriorityFilter !== '') params.priority = Number(yeuCauPriorityFilter);
    dispatch(nhiemVuCaNhanGetYeuCauTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, yeuCauStatusFilter, yeuCauPriorityFilter]);

  // load hotro
  useEffect(() => {
    const params = {};
    if (hoTroStatusFilter !== '') params.status = Number(hoTroStatusFilter);
    if (hoTroLoaiLoiFilter !== '') params.loaiLoi = Number(hoTroLoaiLoiFilter);
    if (hoTroMucDoFilter !== '') params.mucDoPhucTap = Number(hoTroMucDoFilter);
    dispatch(nhiemVuCaNhanGetHoTroTasksAction(Object.keys(params).length ? params : null));
  }, [dispatch, hoTroStatusFilter, hoTroLoaiLoiFilter, hoTroMucDoFilter]);

  const getLinhVucNameById = (id) => {
    if (id == null) return '';
    if (!Array.isArray(linhVucList) || linhVucList.length === 0) return '';

    const found = linhVucList.find((x) => x?.id === id);
    return pickName(found) || '';
    };

    const getKhoaCodesByIds = (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return '';
        if (!Array.isArray(khoaList) || khoaList.length === 0) return '';

        const codes = ids
            .map((kid) => khoaList.find((k) => k?.id === kid)?.maKhoa)
            .filter(Boolean);

        return codes.join(', ');
    };

    const getNguoiPhoiHopNamesByIds = (ids) => {
        if (!Array.isArray(ids) || ids.length === 0) return '';
        if (!Array.isArray(nguoiPhoiHopList) || nguoiPhoiHopList.length === 0) return '';

        return ids
            .map((pid) => nguoiPhoiHopList.find((p) => p?.id === pid)?.name)
            .filter(Boolean)
            .join(', ');
        };

  const sortedProjectTasks = useMemo(() => {
    if (!projectTasks) return [];
    return [...projectTasks].sort((a, b) => {
      const da = a.hanChot ? new Date(a.hanChot) : null;
      const db = b.hanChot ? new Date(b.hanChot) : null;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da - db;
    });
  }, [projectTasks]);

  const sortedOtherTasks = useMemo(() => {
    if (!otherTasks) return [];
    return [...otherTasks].sort((a, b) => {
      const da = a.hanChot ? new Date(a.hanChot) : null;
      const db = b.hanChot ? new Date(b.hanChot) : null;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da - db;
    });
  }, [otherTasks]);

  const sortedYeuCauTasks = useMemo(() => {
    if (!yeuCauTasks) return [];
    return [...yeuCauTasks].sort((a, b) => {
      const da = a.ngayHoanThanhDuKien ? new Date(a.ngayHoanThanhDuKien) : null;
      const db = b.ngayHoanThanhDuKien ? new Date(b.ngayHoanThanhDuKien) : null;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return da - db;
    });
  }, [yeuCauTasks]);

  const sortedHoTroTasks = useMemo(() => {
    if (!hoTroTasks) return [];
    return [...hoTroTasks].sort((a, b) => {
      const da = a.ngayHoTro ? new Date(a.ngayHoTro) : null;
      const db = b.ngayHoTro ? new Date(b.ngayHoTro) : null;
      if (!da && !db) return 0;
      if (!da) return 1;
      if (!db) return -1;
      return db - da; // mới nhất lên trước
    });
  }, [hoTroTasks]);

  // paging data
  const pagedProjectTasks = sortedProjectTasks.slice((pageProject - 1) * pageSizeProject, pageProject * pageSizeProject);
  const pagedOtherTasks = sortedOtherTasks.slice((pageOther - 1) * pageSizeOther, pageOther * pageSizeOther);
  const pagedYeuCauTasks = sortedYeuCauTasks.slice((pageYeuCau - 1) * pageSizeYeuCau, pageYeuCau * pageSizeYeuCau);
  const pagedHoTroTasks = sortedHoTroTasks.slice((pageHoTro - 1) * pageSizeHoTro, pageHoTro * pageSizeHoTro);

  const totalProjectTasks = sortedProjectTasks.length;
  const totalOtherTasks = sortedOtherTasks.length;
  const totalYeuCauTasks = sortedYeuCauTasks.length;
    const totalHoTroTasks = sortedHoTroTasks.length;

    

  return (
    <div className="container-fluid">
      <div className="row mb-2">
        <div className="col-sm-6">
          <h3 className="card-title mb-0">Nhiệm vụ cá nhân</h3>
        </div>
        <div className="col-sm-6 text-right">
          {currentUser && (
            <span className="text-muted">
              Đang hiển thị nhiệm vụ của <strong>{currentUser.fullName || currentUser.username}</strong>
              {currentUser.email ? ` (${currentUser.email})` : ''}
            </span>
          )}
        </div>
      </div>

      <div className="row mb-3">
        <div className="col-12 d-flex justify-content-start">
          <div className="btn-group btn-group-sm">
            <button
              type="button"
              className={`btn ${filterTab === 'all' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('all')}
            >
              Tất cả
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'dev' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('dev')}
            >
              Phát triển phần mềm
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'other' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('other')}
            >
              Nhiệm vụ khác
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'yeucau' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('yeucau')}
            >
              Xử lý yêu cầu
            </button>
            <button
              type="button"
              className={`btn ${filterTab === 'hotro' ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={() => setFilterTab('hotro')}
            >
              Hỗ trợ phần mềm
            </button>
          </div>
        </div>
      </div>

      {loading && (
        <div className="text-center my-4">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
        </div>
      )}

      {!loading && (errorUser || errorProjectTasks || errorOtherTasks || errorYeuCauTasks || errorHoTroTasks) && (
        <div className="alert alert-danger">
          {errorUser && <div>- {String(errorUser)}</div>}
          {errorProjectTasks && <div>- {String(errorProjectTasks)}</div>}
          {errorOtherTasks && <div>- {String(errorOtherTasks)}</div>}
          {errorYeuCauTasks && <div>- {String(errorYeuCauTasks)}</div>}
          {errorHoTroTasks && <div>- {String(errorHoTroTasks)}</div>}
        </div>
      )}

      {!loading && !errorUser && !errorProjectTasks && !errorOtherTasks && !errorYeuCauTasks && !errorHoTroTasks && (
        <>
          {/* DEV */}
          {(filterTab === 'all' || filterTab === 'dev') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Công việc Phát triển phần mềm</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeProject}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeProject(newSize);
                            setPageProject(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={projectStatusFilter}
                          onChange={(e) => {
                            setProjectStatusFilter(e.target.value);
                            setPageProject(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_CONG_VIEC_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={projectPriorityFilter}
                          onChange={(e) => {
                            setProjectPriorityFilter(e.target.value);
                            setPageProject(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setProjectStatusFilter('');
                            setProjectPriorityFilter('');
                            setPageProject(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: 70 }} className="text-center">STT</th>
                            <th>Tên công việc</th>
                            <th>Dự án</th>
                            <th>Bước</th>
                            <th>Mức độ</th>
                            <th>Trạng thái</th>
                            <th>Tiến độ</th>
                            <th>Bắt đầu</th>
                            <th>Hạn chót</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedProjectTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có công việc dự án nào được giao cho bạn.
                              </td>
                            </tr>
                          )}

                          {pagedProjectTasks.map((item, index) => (
                            <tr key={item.assignmentId || item.congViecId || index}>
                              <td className="text-center">
                                {index + 1 + (pageProject - 1) * pageSizeProject}
                              </td>
                              <td className="font-weight-bold">{safeText(item.title)}</td>
                              <td>{safeText(item.projectName)}</td>
                              <td>{safeText(item.projectStepName)}</td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                              <td>
                                <span style={getStatusStyleProject(item.status)}>
                                  {mapTrangThaiCongViecLabel(item.status)}
                                </span>
                              </td>
                              <td className="text-center">
                                {(() => {
                                    const td = getEffectiveTienDoProjectTask(item);
                                    return td != null ? `${td}%` : '';
                                })()}
                              </td>

                              <td>{formatDate(item.ngayBatDau)}</td>
                              <td>{formatDate(item.hanChot)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageProject}
                        itemsCountPerPage={Number(pageSizeProject)}
                        totalItemsCount={totalProjectTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageProject(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* OTHER */}
          {(filterTab === 'all' || filterTab === 'other') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Nhiệm vụ khác</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeOther}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeOther(newSize);
                            setPageOther(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={otherStatusFilter}
                          onChange={(e) => {
                            setOtherStatusFilter(e.target.value);
                            setPageOther(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_KHAC_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={otherPriorityFilter}
                          onChange={(e) => {
                            setOtherPriorityFilter(e.target.value);
                            setPageOther(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setOtherStatusFilter('');
                            setOtherPriorityFilter('');
                            setPageOther(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: 70 }} className="text-center">STT</th>
                            <th>Nhiệm vụ</th>
                            <th>Công việc con</th>
                            <th>Mức độ</th>
                            <th>Trạng thái</th>
                            <th>Tiến độ</th>
                            <th>Ngày giao</th>
                            <th>Hạn chót</th>
                            <th>Người giao</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedOtherTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có nhiệm vụ khác nào được giao cho bạn.
                              </td>
                            </tr>
                          )}

                          {pagedOtherTasks.map((item, index) => (
                            <tr key={item.nhiemVuId || index}>
                              <td className="text-center">
                                {index + 1 + (pageOther - 1) * pageSizeOther}
                              </td>
                              <td><div className="font-weight-bold">{safeText(item.title)}</div></td>
                              <td>
                                <div className="text-muted small">
                                  {item.tongSoCongViecCon > 0
                                    ? `${item.soCongViecConHoanThanh}/${item.tongSoCongViecCon}`
                                    : '0/0'}
                                </div>
                              </td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                              <td>
                                <span style={getStatusStyleNhiemVuKhac(item.status)}>
                                  {mapTrangThaiKhacLabel(item.status)}
                                </span>
                              </td>
                              <td>{item.tienDo != null ? `${item.tienDo}%` : ''}</td>
                              <td>{formatDate(item.ngayGiao)}</td> 
                              <td>{formatDate(item.hanChot)}</td>
                              <td>{safeText(item.nguoiGiao)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageOther}
                        itemsCountPerPage={Number(pageSizeOther)}
                        totalItemsCount={totalOtherTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageOther(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* YEUCAU */}
          {(filterTab === 'all' || filterTab === 'yeucau') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Xử lý yêu cầu</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeYeuCau}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeYeuCau(newSize);
                            setPageYeuCau(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={yeuCauStatusFilter}
                          onChange={(e) => {
                            setYeuCauStatusFilter(e.target.value);
                            setPageYeuCau(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_YEU_CAU_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Ưu tiên:</label>
                        <select
                          className="form-control"
                          value={yeuCauPriorityFilter}
                          onChange={(e) => {
                            setYeuCauPriorityFilter(e.target.value);
                            setPageYeuCau(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_UU_TIEN.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setYeuCauStatusFilter('');
                            setYeuCauPriorityFilter('');
                            setPageYeuCau(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: 70 }} className="text-center">STT</th>
                            <th>Lĩnh vực</th>
                            <th>Khoa</th>
                            <th>Ngày bắt đầu</th>
                            <th>Dự kiến kết thúc</th>
                            <th>Ưu tiên</th>
                            <th>Nội dung</th>
                            <th>Ticket</th>
                            <th>Người phối hợp</th>
                            <th>Trạng thái</th>
                            <th>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedYeuCauTasks.length === 0 && (
                            <tr>
                              <td colSpan={11} className="text-center text-muted">
                                Chưa có xử lý yêu cầu nào liên quan đến bạn.
                              </td>
                            </tr>
                          )}

                          {pagedYeuCauTasks.map((item, index) => (
                            <tr key={item.id || index}>
                              <td className="text-center">
                                {index + 1 + (pageYeuCau - 1) * pageSizeYeuCau}
                              </td>
                              <td>{getLinhVucNameById(item.linhVucId) || item.linhVucId}</td>
                              <td style={{ width: 110, whiteSpace: '' }}>
                                {getKhoaCodesByIds(item.khoaIds) || ''}
                              </td>

                              <td>{formatDate(item.ngayBatDau)}</td>
                              <td>{formatDate(item.ngayHoanThanhDuKien)}</td>
                              <td>{mapMucDoUuTienLabel(item.mucDo)}</td>
                                  <td style={{ minWidth: 220, whiteSpace: 'pre-wrap', wordBreak: 'break-word' }}>{safeText(item.noiDung)}</td>
                              <td className="text-center" style={{ width: 90, whiteSpace: '' }}>
                                {renderTicketLink(item.linkTicket)}
                              </td>

                              <td style={{ minWidth: 180 }}>
                                {getNguoiPhoiHopNamesByIds(item.nguoiPhoiHopIds) || '-'}
                              </td>

                              <td>
                                <span style={getStatusStyleYeuCau(item.status)}>
                                  {mapTrangThaiYeuCauLabel(item.status)}
                                </span>
                              </td>
                              <td style={{ minWidth: 200 }}>{safeText(item.ghiChu)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageYeuCau}
                        itemsCountPerPage={Number(pageSizeYeuCau)}
                        totalItemsCount={totalYeuCauTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageYeuCau(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}

          {/* HOTRO */}
          {(filterTab === 'all' || filterTab === 'hotro') && (
            <Row>
              <Col md={12}>
                <Card className="mb-4">
                  <Card.Header>
                    <h3 className="card-title mb-0">Hỗ trợ phần mềm</h3>
                  </Card.Header>
                  <Card.Body>
                    <div className="d-flex justify-content-between mb-2 flex-wrap">
                      <form className="form-inline mb-2">
                        <label className="mr-2">Hiển thị :</label>
                        <select
                          className="form-control"
                          value={pageSizeHoTro}
                          onChange={(e) => {
                            const newSize = parseInt(e.target.value, 10) || 20;
                            setPageSizeHoTro(newSize);
                            setPageHoTro(1);
                          }}
                        >
                          {objectShowNumber.map((item, key) => (
                            <option key={key} value={item.value}>
                              {item.text}
                            </option>
                          ))}
                        </select>
                      </form>

                      <div className="form-inline mb-2">
                        <label className="mr-2">Trạng thái:</label>
                        <select
                          className="form-control mr-2"
                          value={hoTroStatusFilter}
                          onChange={(e) => {
                            setHoTroStatusFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {TRANG_THAI_HO_TRO_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Loại lỗi:</label>
                        <select
                          className="form-control mr-2"
                          value={hoTroLoaiLoiFilter}
                          onChange={(e) => {
                            setHoTroLoaiLoiFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {LOAI_LOI_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <label className="mr-2">Mức độ:</label>
                        <select
                          className="form-control"
                          value={hoTroMucDoFilter}
                          onChange={(e) => {
                            setHoTroMucDoFilter(e.target.value);
                            setPageHoTro(1);
                          }}
                        >
                          <option value="">Tất cả</option>
                          {MUC_DO_PHUC_TAP_OPTIONS.map((item) => (
                            <option key={item.value} value={item.value}>
                              {item.label}
                            </option>
                          ))}
                        </select>

                        <button
                          type="button"
                          className="btn btn-outline-secondary btn-sm ml-2"
                          onClick={() => {
                            setHoTroStatusFilter('');
                            setHoTroLoaiLoiFilter('');
                            setHoTroMucDoFilter('');
                            setPageHoTro(1);
                          }}
                        >
                          Xóa lọc
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive">
                      <Table striped bordered hover className="mb-0 align-middle">
                        <thead>
                          <tr>
                            <th style={{ width: 70 }} className="text-center">STT</th>
                            <th>Lĩnh vực</th>
                            <th>Ngày hỗ trợ</th>
                            <th>Nội dung</th>
                            <th>Trạng thái</th>
                            <th>Khoa</th>
                            <th>Loại lỗi</th>
                            <th>Mức độ</th>
                            <th>Ghi chú</th>
                          </tr>
                        </thead>
                        <tbody>
                          {pagedHoTroTasks.length === 0 && (
                            <tr>
                              <td colSpan={9} className="text-center text-muted">
                                Chưa có hỗ trợ phần mềm nào liên quan đến bạn.
                              </td>
                            </tr>
                          )}

                          {pagedHoTroTasks.map((item, index) => (
                            <tr key={`${item.linhVucId || ''}-${item.ngayHoTro || ''}-${index}`}>
                              <td className="text-center">
                                {index + 1 + (pageHoTro - 1) * pageSizeHoTro}
                              </td>
                              <td>{getLinhVucNameById(item.linhVucId) || item.linhVucId}</td>
                              <td>{formatDate(item.ngayHoTro)}</td>
                              <td style={{ minWidth: 240 }}>{safeText(item.noiDung)}</td>
                              <td>
                                <span style={getStatusStyleHoTro(item.status)}>
                                  {mapTrangThaiHoTroLabel(item.status)}
                                </span>
                              </td>
                              <td style={{ width: 110, whiteSpace: '' }}>
                                {getKhoaCodesByIds(item.khoaIds) || ''}
                              </td>

                              <td>{item.loaiLoi != null ? mapLoaiLoiLabel(item.loaiLoi) : ''}</td>
                              <td>{item.mucDoPhucTap != null ? mapMucDoPhucTapLabel(item.mucDoPhucTap) : ''}</td>
                              <td style={{ minWidth: 200 }}>{safeText(item.ghiChu)}</td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>

                    <div className="dataTables_paginate paging_simple_numbers mt-2">
                      <Pagination
                        itemClass="page-item"
                        linkClass="page-link"
                        innerClass="pagination pagination-sm no-margin pull-right"
                        activePage={pageHoTro}
                        itemsCountPerPage={Number(pageSizeHoTro)}
                        totalItemsCount={totalHoTroTasks}
                        pageRangeDisplayed={5}
                        onChange={(n) => setPageHoTro(n)}
                      />
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          )}
        </>
      )}
    </div>
  );
};

export default NhiemVuCaNhan;
